import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceindelhincr() {



  const cardData =
  {
    keyword: ' Corporate Cab Services in Delhi NCR',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services in Delhi NCR',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Services in Delhi NCR, catering to the transportation needs of corporate offices, IT parks, business hubs, and industrial areas across the region. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and timely travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Delhi NCR.',

    top: 'Top Places to Visit in Delhi with Pune Corporate Car',

"topPlaces": [
  {
    "title": "India Gate",
    "description": "India Gate is a towering war memorial located at the heart of New Delhi, built to honor soldiers of the British Indian Army who died in World War I. Surrounded by wide lawns and beautiful avenues, it is a popular spot for picnics, evening walks, and photography. The Amar Jawan Jyoti, an eternal flame, adds a solemn and reflective atmosphere. Street vendors selling snacks, flowers, and souvenirs create a lively environment, especially during evenings and weekends."
  },
  {
    "title": "Red Fort",
    "description": "The Red Fort is a UNESCO World Heritage Site and a symbol of Mughal architecture in Delhi. Built in 1639 by Emperor Shah Jahan, the fort’s massive red sandstone walls, intricate carvings, and grand gates showcase the grandeur of the Mughal era. Visitors can explore Diwan-i-Aam, Diwan-i-Khas, and museums inside, while the fort hosts the annual Independence Day flag-hoisting ceremony, attracting thousands of spectators."
  },
  {
    "title": "Qutub Minar",
    "description": "Qutub Minar is the tallest brick minaret in the world, standing at 73 meters, and a UNESCO World Heritage Site. Built in 1193, it features intricate Indo-Islamic architecture with inscriptions and carvings. The surrounding Qutub complex includes ancient tombs, mosques, and lush gardens, offering history enthusiasts a serene space for exploration, photography, and educational trips."
  },
  {
    "title": "Humayun’s Tomb",
    "description": "Humayun’s Tomb is a magnificent Mughal mausoleum built in 1570, renowned for its Persian-style architecture and beautifully landscaped gardens. It is considered a precursor to the Taj Mahal and is a UNESCO World Heritage Site. The tomb’s symmetrical design, water channels, and tranquil environment make it an ideal spot for history lovers, photographers, and visitors seeking a peaceful retreat in Delhi."
  },
  {
    "title": "Lotus Temple",
    "description": "The Lotus Temple, also called the Bahá’í House of Worship, is famous for its lotus-shaped architecture and serene surroundings. Open to people of all faiths, it provides a peaceful environment for meditation, reflection, and spiritual exploration. The temple’s gardens, water pools, and quiet ambiance enhance the visitor experience, making it a unique spiritual and architectural landmark."
  },
  {
    "title": "Akshardham Temple",
    "description": "Akshardham Temple is a modern cultural and spiritual complex showcasing traditional Indian architecture, art, and heritage. The sprawling site includes intricately carved stone temples, exhibitions on Indian history, musical fountains, and lush gardens. Visitors can explore the temple, attend cultural shows, and enjoy the evening light and sound display, offering both educational and spiritual experiences."
  },
  {
    "title": "Connaught Place",
    "description": "Connaught Place is New Delhi’s commercial and social hub, featuring colonial-era architecture, circular plazas, and bustling streets with shops, restaurants, and cafés. It is ideal for shopping, dining, nightlife, and people-watching. The central park hosts events and festivals, making it a lively and vibrant area that combines history, commerce, and leisure."
  },
  {
    "title": "Jama Masjid",
    "description": "Jama Masjid, one of India’s largest mosques, was built in 1656 by Emperor Shah Jahan. The mosque features grand red sandstone and marble architecture, spacious courtyards, and tall minarets. Visitors can climb the minarets for panoramic views of Old Delhi, explore the bustling surrounding bazaars, and experience the rich cultural and spiritual atmosphere of the area."
  },
  {
    "title": "Raj Ghat",
    "description": "Raj Ghat is the memorial dedicated to Mahatma Gandhi, marked by a simple black marble platform amidst serene gardens. It is a place of reflection, visited by people from across India and the world. The peaceful surroundings, eternal flame, and commemorative plaques make it a revered site for learning about Gandhi’s life and philosophy."
  },
  {
    "title": "Lodhi Gardens",
    "description": "Lodhi Gardens is a historic park blending natural beauty with architectural heritage. It features tombs from the Lodhi dynasty, landscaped gardens, walking and jogging paths, and tree-lined avenues. The park is a favorite spot for morning walkers, families, photographers, and tourists seeking a calm, scenic, and recreational environment in the midst of Delhi’s urban landscape."
  }
],


"services": [
{
"name": "Delhi NCR Corporate Shuttle",
"description": "Delhi NCR Corporate Shuttle provides seamlessly organized transportation services for corporate offices, business parks, IT hubs, and industrial units across the NCR region. With professionally managed shuttle routes, GPS-enabled vehicles, trained chauffeurs, and multi-shift support, the service ensures smooth large-scale employee mobility. Companies rely on this shuttle system for reliability, safety, punctuality, bulk staff movement, and operational efficiency across Delhi, Gurgaon, Noida, Greater Noida, and Faridabad."
},
{
"name": "NCR Employee Transportation",
"description": "NCR Employee Transportation offers comprehensive commuting solutions for employees working across business districts, industrial zones, and IT parks in the National Capital Region. The service includes advanced routing, professional drivers, real-time GPS tracking, automated scheduling, and multi-shift operations. With a focus on safe, comfortable, and timely travel, it supports daily staff movement for corporates, factories, warehouses, and tech companies."
},
{
"name": "Company Cab Delhi NCR",
"description": "Company Cab Delhi NCR delivers dedicated corporate cab services tailored for businesses requiring reliable employee and executive transport. The service features air-conditioned sedans and SUVs, well-trained drivers, strict safety protocols, and real-time trip monitoring. Designed to enhance corporate mobility, it supports office commute, client travel, business meetings, and management-level transfers across the NCR region."
},
{
"name": "Staff Pickup Drop NCR",
"description": "Staff Pickup Drop NCR ensures structured and well-coordinated employee commuting for corporate offices, industrial units, and IT companies. The service features punctual pickups, optimized routes, GPS-enabled cabs, professional drivers, and multi-shift operational capability. It ensures seamless, hassle-free, and dependable daily commuting for thousands of employees in the region."
},
{
"name": "Business Cab Delhi NCR",
"description": "Business Cab Delhi NCR offers premium travel services designed for corporate executives, business travelers, and office staff. With well-maintained sedans, SUVs, trained chauffeurs, and real-time monitoring, the service ensures professional, punctual, and efficient travel for meetings, site visits, airport transfers, and corporate events."
},
{
"name": "Best Corporate Cabs NCR",
"description": "Best Corporate Cabs NCR provides high-end transportation services for enterprises seeking safe, reliable, and professional mobility solutions. The service includes luxury sedans, executive SUVs, trained drivers, route optimization, and end-to-end corporate mobility management. Ideal for daily commute, VIP transfers, and employee transport at scale."
},
{
"name": "Affordable Employee Cab NCR",
"description": "Affordable Employee Cab NCR offers cost-effective corporate and staff transportation without compromising safety or service quality. The service includes comfortable vehicles, trained drivers, GPS-enabled tracking, and efficient routing to ensure budget-friendly but dependable office commuting for businesses and industrial units across the region."
},
{
"name": "Monthly Corporate Cab NCR",
"description": "Monthly Corporate Cab NCR delivers long-term transportation solutions for companies requiring stable, consistent, and reliable employee mobility. With fixed monthly pricing, dedicated cabs, professional chauffeurs, and automated schedules, the service ensures smooth daily operations for corporate offices, manufacturing units, and IT parks across NCR."
},
{
"name": "Outstation Cab Delhi NCR",
"description": "Outstation Cab Delhi NCR offers safe, comfortable, and reliable long-distance travel for business trips, site visits, factory inspections, and interstate corporate travel. The service features GPS-enabled sedans and SUVs, trained long-route drivers, flexible scheduling, and seamless intercity connectivity to major destinations around Delhi NCR."
},
{
"name": "Sedan Cab Delhi NCR",
"description": "Sedan Cab Delhi NCR provides executive sedans for corporate mobility, daily office commute, client travel, and management-level movement. With comfortable interiors, experienced chauffeurs, GPS tracking, and punctual operations, the service ensures smooth, professional, and safe transportation across the NCR region."
},
{
"name": "SUV Cab Delhi NCR",
"description": "SUV Cab Delhi NCR delivers spacious, premium SUV transportation ideal for team movement, corporate visits, long-distance travel, and executive mobility. The service ensures high comfort, professional drivers, route optimization, and top-tier travel experience for corporate and industrial requirements."
},
{
"name": "Corporate Fleet Delhi NCR",
"description": "Corporate Fleet Delhi NCR offers complete fleet management solutions for companies seeking dedicated vehicles for staff commute, executive transport, and logistics-based mobility. The service includes sedans, SUVs, shuttles, GPS tracking, driver allocation, fleet maintenance, and route planning for large-scale employee operations."
},
{
"name": "Factory Worker Transport NCR",
"description": "Factory Worker Transport NCR specializes in safe, timely, and large-scale transportation for industrial and factory staff. The service includes multi-capacity vehicles, shift-based scheduling, GPS monitoring, trained drivers, and industrial-area route expertise to support seamless workforce mobility across NCR’s manufacturing hubs."
},
{
"name": "Executive Cab Delhi NCR",
"description": "Executive Cab Delhi NCR provides premium chauffeur-driven travel for senior management, VIP guests, and high-profile corporate personnel. With luxury sedans and SUVs, professionally trained chauffeurs, strict safety protocols, and punctual service, it ensures an exceptional executive travel experience."
},
{
"name": "Office Staff Commute NCR",
"description": "Office Staff Commute NCR delivers structured commuting services for corporate employees, offering reliable pickups, optimized routing, GPS-monitored cabs, and professional drivers. Designed for daily office operations, it ensures punctual, comfortable, and efficient travel for staff across the NCR region."
}
],

"tableData": [
["Delhi NCR Corporate Shuttle", "NCR Employee Transportation"],
["Company Cab Delhi NCR", "Staff Pickup Drop NCR"],
["Business Cab Delhi NCR", "Best Corporate Cabs NCR"],
["Affordable Employee Cab NCR", "Monthly Corporate Cab NCR"],
["Outstation Cab Delhi NCR", "Sedan Cab Delhi NCR"],
["SUV Cab Delhi NCR", "Corporate Fleet Delhi NCR"],
["Factory Worker Transport NCR", "Executive Cab Delhi NCR"],
["Office Staff Commute NCR", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Delhi NCR",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides dependable corporate cab services across Delhi NCR, ensuring smooth, safe, and efficient transportation for employees and business executives."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs throughout Delhi, Gurgaon, Noida, and Greater Noida, helping employees reach workplaces and business hubs on time."
  },
  {
    "WhyChooseheading": "Professional & Skilled Drivers",
    "WhyChoosedescription": "Our experienced chauffeurs follow corporate travel standards, ensuring safe, courteous, and comfortable commuting for employees and executives across NCR."
  },
  {
    "WhyChooseheading": "Well-Maintained & Diverse Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—regularly sanitized, serviced, and maintained for a smooth corporate travel experience."
  },
  {
    "WhyChooseheading": "Custom Corporate Travel Packages",
    "WhyChoosedescription": "We provide customized cab rental plans tailored to the commuting needs of companies operating across the Delhi NCR region."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our support team is available round-the-clock to assist with bookings, emergencies, and travel adjustments, ensuring uninterrupted transportation."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Corporate Rides",
    "WhyChoosedescription": "All vehicles are sanitized frequently and equipped with advanced safety features, offering secure and hygienic commuting for employees and executives."
  },
  {
    "WhyChooseheading": "Smooth Booking & Coordination",
    "WhyChoosedescription": "Our streamlined booking system and efficient coordination make corporate travel management effortless and hassle-free for businesses."
  }
]





























  }

const faqData = [
  {
    question: 'Do you provide corporate cab services in Delhi NCR?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers professional and reliable corporate cab services for companies and employees across Delhi NCR.',
  },
  {
    question: 'What types of corporate cab services are available in Delhi NCR?',
    answer: 'We provide employee transportation, corporate pickups and drops, airport transfers, shuttle services, and dedicated fleet solutions for businesses.',
  },
  {
    question: 'Do you support daily employee commuting in Delhi NCR?',
    answer: 'Yes, we offer optimized daily commute solutions with timely pickups and flexible shift scheduling across Delhi, Gurgaon, and Noida.',
  },
  {
    question: 'How can companies book corporate cab services in Delhi NCR?',
    answer: 'Bookings can be made through our website, mobile app, or by contacting our 24×7 corporate support team.',
  },
  {
    question: 'What vehicle options are available for corporate cab services in Delhi NCR?',
    answer: 'We offer hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers based on corporate requirements.',
  },
  {
    question: 'Do you offer long-term corporate cab contracts in Delhi NCR?',
    answer: 'Yes, we provide monthly, quarterly, and annual transportation contracts with flexible and transparent pricing options.',
  },
  {
    question: 'Are safety and monitoring features included in corporate cab services?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by verified and trained chauffeurs to ensure employee safety.',
  },
  {
    question: 'Do you provide multi-shift transportation schedules in Delhi NCR?',
    answer: 'Yes, we manage early morning, evening, night, and rotational shift transportation for corporate employees.',
  },
  {
    question: 'What payment options are available for corporate cab services in Delhi NCR?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and offer monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Kunal Bhatia',
    feedback: 'Excellent corporate cab service across Delhi NCR. Timely, safe, and very well-managed transportation for our employees.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Radhika Soni',
    feedback: 'Very professional and reliable service for our Delhi NCR offices. Smooth coordination and comfortable rides every day.',
    rating: 5,
  },
];


































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Delhi NCR",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-delhi-ncr.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited offers reliable corporate cab services in Delhi NCR, including employee transportation, staff pickup & drop, corporate shuttles, business cabs, monthly corporate cab plans, outstation trips, factory worker transport, and executive chauffeur-driven vehicles for seamless office and corporate mobility in the NCR region.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-delhi-ncr"
  }
};




  return (
    <div>
<Helmet>
  <title>Corporate Cab Services in Delhi NCR | Employee & Business Transport</title>

  <meta
    name="description"
    content="Premium corporate cab services in Delhi NCR including employee transportation, corporate shuttle, staff pickup & drop, business cabs, monthly corporate cab plans, outstation trips, factory worker transport, and executive chauffeur-driven vehicles for companies in NCR."
  />

  <meta
    name="keywords"
    content="Delhi NCR Corporate Shuttle, NCR Employee Transportation, Company Cab Delhi NCR, Staff Pickup Drop NCR, Business Cab Delhi NCR, Best Corporate Cabs NCR, Affordable Employee Cab NCR, Monthly Corporate Cab NCR, Outstation Cab Delhi NCR, Sedan Cab Delhi NCR, SUV Cab Delhi NCR, Corporate Fleet Delhi NCR, Factory Worker Transport NCR, Executive Cab Delhi NCR, Office Staff Commute NCR"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/58.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceindelhincr;